
export default function Confidentialite() {
  return (
    <div className="min-h-screen bg-white py-16">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Politique de Confidentialité</h1>
          <div className="h-1 w-20 bg-[#9EFD38]"></div>
        </div>

        <div className="prose prose-lg max-w-none">
          <div className="bg-[#9EFD38]/10 p-6 rounded-lg mb-8">
            <p className="text-gray-700 text-lg">
              Chez VirtualEat, la protection de vos données personnelles est une priorité. 
              Cette politique explique quelles informations nous collectons, pourquoi, et comment elles sont utilisées.
            </p>
          </div>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Responsable du traitement</h2>
            <p className="text-gray-700 mb-2">Le responsable du traitement est :</p>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-gray-700 font-semibold">VirtualEat – Gabriel Marandyuk</p>
              <p className="text-gray-700">Email : gabrielmarandyukpro@gmail.com</p>
              <p className="text-gray-700">Téléphone : +32 493 81 35 52</p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Données collectées</h2>
            <p className="text-gray-700 mb-4">
              Nous collectons uniquement les informations nécessaires à la prise de contact et au suivi commercial :
            </p>
            <ul className="list-disc list-inside text-gray-700 ml-4 space-y-2">
              <li>Nom et prénom</li>
              <li>Adresse email</li>
              <li>Numéro de téléphone</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Finalités de la collecte</h2>
            <p className="text-gray-700 mb-4">Vos données sont utilisées pour :</p>
            <ul className="list-disc list-inside text-gray-700 ml-4 space-y-2">
              <li>Vous recontacter suite à votre demande via le formulaire</li>
              <li>Vous proposer un rendez-vous ou des informations sur nos services</li>
              <li>Vous informer de mises à jour ou nouveautés de VirtualEat</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Base légale</h2>
            <p className="text-gray-700 mb-4">La collecte de vos données repose sur :</p>
            <ul className="list-disc list-inside text-gray-700 ml-4 space-y-2">
              <li>Votre consentement (formulaire rempli volontairement)</li>
              <li>L'intérêt légitime de VirtualEat à vous proposer ses services</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Conservation des données</h2>
            <p className="text-gray-700">
              Vos données sont conservées pour une durée maximale de 3 ans après notre dernier contact, puis supprimées.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Partage des données</h2>
            <p className="text-gray-700 mb-4">
              Vos informations ne sont jamais vendues ni cédées à des tiers.
            </p>
            <p className="text-gray-700">
              Elles peuvent uniquement être transmises à nos prestataires techniques (hébergeur, outils de mailing) 
              dans le cadre strict de nos activités.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Sécurité des données</h2>
            <p className="text-gray-700">
              Nous mettons en place toutes les mesures techniques et organisationnelles pour protéger vos informations 
              (cryptage, accès restreint, hébergement sécurisé).
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Vos droits (RGPD)</h2>
            <p className="text-gray-700 mb-4">
              Conformément à la législation en vigueur, vous disposez de :
            </p>
            <div className="grid md:grid-cols-2 gap-2 mb-4">
              <ul className="list-disc list-inside text-gray-700 ml-4 space-y-1">
                <li>Droit d'accès à vos données</li>
                <li>Droit de rectification</li>
                <li>Droit de suppression</li>
              </ul>
              <ul className="list-disc list-inside text-gray-700 ml-4 space-y-1">
                <li>Droit d'opposition</li>
                <li>Droit à la portabilité</li>
              </ul>
            </div>
            <div className="bg-[#9EFD38]/10 p-4 rounded-lg">
              <p className="text-gray-700 font-semibold">
                Pour exercer vos droits : 
                <a href="mailto:gabrielmarandyukpro@gmail.com" className="text-[#9EFD38] hover:underline ml-1">
                  gabrielmarandyukpro@gmail.com
                </a>
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Cookies</h2>
            <p className="text-gray-700 mb-4">Le site peut utiliser des cookies pour :</p>
            <ul className="list-disc list-inside text-gray-700 ml-4 mb-4">
              <li>Analyser la fréquentation (Google Analytics, etc.)</li>
            </ul>
            <p className="text-gray-700">
              Vous pouvez à tout moment désactiver les cookies dans les paramètres de votre navigateur.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <a 
            href="/"
            className="inline-flex items-center text-[#9EFD38] hover:text-[#8AE832] font-semibold transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Retour à l'accueil
          </a>
        </div>
      </div>
    </div>
  );
}